import { usePincode } from '@/shared/features/pincode/presentation/hooks/usePincode';

export function usePlpPincode() {
  return usePincode();
}

